module.exports = __webpack_public_path__ + "img/cashPay.826e34d0.svg";